import type { ComponentType } from 'react';
import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactClusterer } from 'src/components/YandexMap/loaders/componentLoaders';
import type {
  Coordinates,
  Point as PointType,
} from 'src/components/YandexMap/types';
import type { ActiveHotelState } from 'src/routes/SeoApp/domain/state/map/types';
import { MAX_ZOOM_FOR_CLUSTER } from './constants';
import ClusterPoint from './components/ClusterPoint';
import type { PointProps } from '../Point/Point';

const YMapClusterer = loadReactClusterer(loadModulePromise);

type PointsProps = {
  isMobile: boolean;
  points: PointType[];
  moveToPoint: (
    coordinates: Coordinates,
    zoomDiff: number,
    offset: { x: number; y: number },
  ) => void;
  activeHotel?: ActiveHotelState;
  Point: ComponentType<PointProps>;
};

const transformPointsToFeatures = (
  points: PointType[],
  activeHotelId: number,
) =>
  points
    // Некоторые отели имеют нули в координатах
    .filter((point) => point.coordinates[0] && point.coordinates[1])
    .map((point, idx) => ({
      type: 'Feature',
      id: idx.toString(),
      active: activeHotelId === point.shortHotelInfo?.id,
      shortHotelInfo: point.shortHotelInfo,
      geometry: { type: 'Point', coordinates: point.coordinates },
    }));

const Clusterer = (props: PointsProps) => {
  const { points, moveToPoint, activeHotel, isMobile, Point } = props;

  return (
    <YMapClusterer
      cluster={(coordinates, features) => (
        <ClusterPoint
          coordinates={coordinates}
          hotelCount={features.length}
          type="Point"
          moveToPoint={moveToPoint}
        />
      )}
      maxZoom={MAX_ZOOM_FOR_CLUSTER}
      marker={(feature) => (
        <Point isMobile={isMobile} moveToPoint={moveToPoint} {...feature} />
      )}
      features={transformPointsToFeatures(points, Number(activeHotel?.id))}
    />
  );
};

export default Clusterer;
